/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { HnaNetworkApprovalState, HnaZone } from '../../../shared/entities/hnaRequest';
import TriStateCheckbox, { TriState } from '../../common/buttons/TriStateCheckbox';
import { networkTypes, useStyles } from './HnaZoneSelector';

export const HnaZoneViewer = (props: any) => {
  const classes = useStyles();
  const [rows, setRows] = useState<HnaZone[]>([]);

  useEffect(() => {
    setRows(props.hnaZones);
  }, [props.hnaZones]);

  return (
    <Box display="flex" flexDirection="column" rowGap="15px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box className={`${classes.dropdown} ${classes.headerText}`}>Hna Zone</Box>
        <Box className={classes.delete}></Box>
        {networkTypes.map(network => {
          return (
            <Box className={`${classes.checkbox} ${classes.headerText}`}>
              <Box textAlign="center">{network.label}</Box>
              <Box textAlign="center">{network.subLabel}</Box>
            </Box>
          );
        })}
      </Box>
      {rows?.map(row => {
        return (
          <HnaZoneRow
            key={row.country}
            currentCountry={row}
          />
        );
      })}
    </Box>
  );
};

const HnaZoneRow = (props: any) => {
  const classes = useStyles();
  const mapNetworkToTriState = (currentNetwork: any) => {
    let selected = props.currentCountry.networks.map((e: { network: any; }) => e.network);
    let networks = props.currentCountry.networks;
    if (selected.includes(currentNetwork.name)) {
      switch (networks[networks.map((e: { network: any; }) => e.network).indexOf(currentNetwork.name)].state) {
        case HnaNetworkApprovalState.REQUESTED:
          return TriState.Blank;
        case HnaNetworkApprovalState.APPROVED:
          return TriState.Approved;
        case HnaNetworkApprovalState.DENIED:
          return TriState.Denied;
        default:
          return undefined;
      }
    } else {
      return undefined;
    }
  };
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Box className={classes.dropdown}>{props.currentCountry.country}</Box>
      <Box className={classes.delete} />
      {networkTypes.map(network => {
        return (
          <Box className={`${classes.checkbox} ${classes.headerText}`}>
            <TriStateCheckbox readOnly={true} sx={{ margin:'auto'}} status={mapNetworkToTriState(network)} />
          </Box>
        );
      })}
    </Box>
  );
};
